import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

export interface LabelProps extends ComponentPropsWithoutRef<'label'> {
  invalid?: boolean;
  required?: boolean;
  hide?: boolean;
}

export function Label({
  invalid,
  children,
  required,
  hide,
  ...props
}: LabelProps) {
  return (
    <label
      className={classNames('flex gap-half', {
        'text-red-600': invalid,
        'sr-only': hide,
        'cursor-pointer': props?.htmlFor,
      })}
      {...props}
    >
      {children}
      {required && (
        <>
          <span aria-hidden className="text-red-600 font-600">
            *
          </span>
          <span className="sr-only">(Required Field)</span>
        </>
      )}
    </label>
  );
}
